module.exports = __webpack_public_path__ + "bdf2bf93e9fa0e80230e0414b07b7d43.fbx";